import _ from "lodash";

export function serializeQueryParamsIntoStr(toBeParams: Record<string, unknown>) {
  return Object.keys(toBeParams)
    .map((key) => {
      const value = toBeParams[key];
      if (value === "") {
        return undefined;
      }

      return _.upperFirst(key) + "=" + value;
    })
    .filter((index) => index !== undefined)
    .join("&");
}

export function deserializeQueryParamsIntoStr(queryStr: string) {
  const payload: Record<string, string> = {};
  const searchParams = new URLSearchParams(queryStr);

  searchParams.forEach((value, key) => {
    payload[key] = value;
  });

  return payload;
}
